import React from 'react';
import Card from '../../atoms/Card';
import Label from '../../atoms/Label';

export interface ReservationAdvanceMessageCardProps {
  title: string;
  message: string;
}

const ReservationAdvanceMessageCard: React.FC<ReservationAdvanceMessageCardProps> = ({ title, message }) => {
  return (
    <Card className='u-ws u-mr16 u-mb16'>
      <Card.Header className='u-pt8'>
        <Label className='u-text-m' label={title} data-testid='reservation-advance-message-card--title' />
      </Card.Header>
      <Card.Content>
        <Label label={message} data-testid={`reservation-advance-message-card--message`} />
      </Card.Content>
    </Card>
  );
};
export default ReservationAdvanceMessageCard;
